import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
Vue.prototype.axios = axios;
import global from './pages/global.vue'
Vue.prototype.Global = global
import router from './router'
Vue.config.productionTip = false

//数学公式解析
import VueKatex from 'vue-katex';
import 'katex/dist/katex.min.css';
Vue.use(VueKatex, {
  globalOptions: {
    
  }
});
//video
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
Vue.use(VideoPlayer)
//element引用
import { Message,MessageBox,Select,Option,Pagination,Popover,Button,Switch,Dialog,Tooltip,DatePicker,TimePicker,Progress,Upload,InputNumber,Dropdown,DropdownMenu,DropdownItem,Tree } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Message.install = function (Vue, options) {
  Vue.prototype.$message = Message
}
Vue.use(Message)
Vue.prototype.$messageBox = MessageBox
Vue.use(Select)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Dialog)
Vue.use(Tooltip)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Progress)
Vue.use(Upload)
Vue.use(InputNumber)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Tree)

import '@/assets/css/style.css'
import '@/assets/css/index.css'
//修改窗口标题
// router.beforeEach((to, from, next)=>{
//   if(to.meta.title){
//     document.title = to.meta.title
//   }
//   next()
// })
import { get, post } from './request/http'
Vue.prototype.$post=post;
Vue.prototype.$get=get;

new Vue({
  render: h => h(App),
	router,
}).$mount('#app')

